<div class="input-grid-gaps grid-2col">
    @if (certExists()) {
        <div class="flex gap justify-content-end align-items-center">
            @if (canEdit()) {
                <app-button icon="pi-plus" label="sickNotes.buttons.assume"
                    (clickEvent)="assumeSickNote()"></app-button>
            }
            @if (canCreate()) {
                <app-button icon="pi-plus" label="sickNotes.buttons.add" (clickEvent)="createSickNote()"></app-button>
            }
        </div>
        <div></div>

        <div class="flex flex-1 notesList">
            <app-table
                #sickNotesTable
                translatePrefix="sickNotes.sickNotesList."
                [columns]="columns"
                [additionalFilter]="additionalFilter()"
                [gridData]="store.data.getSickNotes()"
                [refreshCallback]="store.api.getSickNotes"
                [refreshCallbackFragment]="folderSickNoteFrag"
                (selectionChanged)="selection($event)"
                [showSearchBar]="false"
                selectionMode="single"
                [defaultSorters]="[{ column: 'id', direction: 'DESC' }]"
            >
            </app-table>
        </div>

        @if (selectedSickNote()) {
            <div class="flex-column flex-1 gap notesInfo">
                <div class="flex justify-content-between flex-gap-small">
                    <div class="flex-column gap-x-small">
                        <label>{{ 'sickNotes.info.registrationNumber' | translate }}:</label>
                        <div>{{ selectedSickNote()?.decisionNumber }}</div>
                    </div>
                    @if (canEdit()) {
                        <app-button icon="pi-folder-open" label="sickNotes.buttons.detailCorrectEnd"
                            (clickEvent)="detail()"></app-button>
                    }
                </div>

                <div class="flex-column gap-x-small">
                    <label
                        class="text-uppercase font-bold">{{ selectedSickNote()?.name }} {{ selectedSickNote()?.surname }}
                        - {{ selectedSickNote()?.insuranceNumber }}</label>
                    <div>{{ selectedSickNote()?.address?.name }}, {{ selectedSickNote()?.address?.location }}</div>
                </div>

                <div class="flex-column gap-x-small">
                    <label>{{ 'sickNotes.info.employment' | translate }}:</label>
                    <div> {{ selectedSickNote()?.employerName }}</div>
                    <div> {{ selectedSickNote()?.employerAddress?.name }}
                        , {{ selectedSickNote()?.employerAddress?.location }}
                    </div>
                </div>

                <div class="flex-column gap-x-small">
                    <label>{{ 'sickNotes.info.dateFrom' | translate }}
                        : {{ selectedSickNote()?.incapacityStartDate | localDate : 'dd.MM.yyyy' }}</label>
                    <label>{{ 'sickNotes.info.diagnosis' | translate }}: {{ selectedSickNote()?.diagnosisCode }}</label>
                    <label>{{ 'sickNotes.info.createdBy' | translate }}: {{ selectedSickNote()?.doctorOrigin }}</label>
                    @if (selectedSickNote()?.walkoutsFromDate) {
                        <label>{{ 'sickNotes.info.walkoutsFrom' | translate }}
                            : {{ selectedSickNote()?.walkoutsFromDate | localDate : 'dd.MM.yyyy' }}
                            {{ selectedSickNote()?.walkoutsFrom1 }} - {{ selectedSickNote()?.walkoutsTo1 }}
                            @if (selectedSickNote()?.walkoutsFrom2) {
                                {{ selectedSickNote()?.walkoutsFrom2 }} - {{ selectedSickNote()?.walkoutsTo2 }}
                            }
                        </label>
                    }
                </div>

                <div class="flex-column gap-x-small">
                    <label>{{ 'sickNotes.info.submissionStatuses' | translate }}:</label>

                    <div class="flex-column gap">
                        @for (event of selectedSickNote()?.events; track $index) {
                            <div>
                                <div>@if (event.fillingType) {
                                    {{ event.fillingType }} -
                                }
                                    {{ 'sickNotes.fillingState.' + event.event | translate }}
                                    @if (event.note) {
                                        - {{ event.note }}
                                    }
                                </div>
                                <div>{{ event.csszEventTime | localDate : 'dd.MM.yyyy HH:mm' }}</div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        }
    }
</div>
